import React from 'react';

class Container extends React.Component {
	constructor(props) {
		super(props);
	}
	componentWillUnmount() {
		document.removeEventListener('copy', handleCopy);
	}
	componentDidMount() {
		document.removeEventListener('copy', handleCopy);
		document.addEventListener('copy', handleCopy);
	}
	render() {
		const { children } = this.props;
		window.deniedToCopyWords = this.props.deniedToCopyWords;

		return <div>
			{children}
		</div>;
	}
}

export default Container;

function handleCopy(e) {
	const deniedToCopyWords = window.deniedToCopyWords || [];

	const text = window
		.getSelection()
		.toString()
		.split(/[\n\r]/)
		.map(row =>
			row.split('\t')
				.filter(item => !deniedToCopyWords.some(aw => item.includes(aw)))
				.join('\t')
		)
		.join('\n');

	e.clipboardData.setData('text/plain', text);
	e.preventDefault();
}


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/no-copy-container/index.js